import { render } from "./Bedland.vue?vue&type=template&id=02ef1ce8"
import script from "./Bedland.vue?vue&type=script&lang=js"
export * from "./Bedland.vue?vue&type=script&lang=js"

import "./Bedland.vue?vue&type=style&index=0&id=02ef1ce8&lang=css"
script.render = render

export default script